import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class IdleTimeoutService {
  private idleTimeout = 30 * 60 * 1000; // 30 minutes in milliseconds
  private idleTimer: any;

  constructor(private msalService: MsalService, private router: Router) {
    this.resetTimer();
  }

  public resetTimer(): void {
    if (this.idleTimer) {
      clearTimeout(this.idleTimer);
    }
    this.idleTimer = setTimeout(() => this.logout(), this.idleTimeout);
  }

  public clearTimer(): void {
    if (this.idleTimer) {
      clearTimeout(this.idleTimer);
    }
  }

  private logout(): void {
    // Clear local session data
    localStorage.clear();
    sessionStorage.clear();
    // Perform logout using MSAL
    this.msalService.logout();
  }
}
